<template>
  <div class="salon-list">
    <div class="salon-list-section">
      <div class="salon-list-title">
        已预订
      </div>
      <div
        class="salon-list-item"
        v-for="item in bookingList"
        :key="item.booking_id"
      >
        <div class="salon-list-item-infor">
          <div class="salon-list-item-infor-left">
            <div class="salon-list-item-infor-name">
              {{ item.room_name }}
            </div>
            <div class="salon-list-item-infor-time">
              时间：{{ item.booking_time }}
            </div>
          </div>
          <div class="salon-list-item-infor-right">
            <el-tag v-if="item.meeting_status === 0">审批中</el-tag>
            <el-tag
              type="success"
              v-if="item.meeting_status === 1"
            >审批通过</el-tag>
          </div>
        </div>
        <div class="salon-list-item-btn">
          <el-button
            type="text"
            @click="cancel(item)"
          >取消日程</el-button>
          <el-button
            type="text"
            @click="goDetail(item)"
          >会议详情</el-button>
        </div>
      </div>

    </div>
    <div class="salon-list-section salon-list-finish">
      <div class="salon-list-title">
        已结束
      </div>
      <div
        class="salon-list-item"
        v-for="item in finishList"
        :key="item.booking_id"
      >
        <div class="salon-list-item-infor">
          <div class="salon-list-item-infor-left">
            <div class="salon-list-item-infor-name">
              {{ item.room_name }}
            </div>
            <div class="salon-list-item-infor-time">
              时间：{{ item.booking_time }}
            </div>
          </div>
          <div class="salon-list-item-infor-right">

          </div>
        </div>
        <div class="salon-list-item-btn">
          <el-button
            type="text"
            @click="goDetail(item)"
          >会议详情</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import meetingService from "@/apis/meeting/index.js";
import getUserInfo from "@/models/userInfo";
import { Dialog, Toast } from "vant";

export default {
  data() {
    return {
      currentUserInfo: {},
      bookingList: [],
      finishList: [],
    };
  },
  async created() {
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getBookingList();
  },
  methods: {
    cancel(item) {
      Dialog.confirm({
        title: "提示",
        message: `是否确认取消${item.booking_time}的预约`,
      })
        .then(() => {
          const { currentUserInfo } = this;
          const params = {
            ding_user_id: currentUserInfo.ding_user_id,
            booking_id: item.booking_id,
          };
          meetingService.bookingCancel(params).then((res) => {
            console.log(res);
            Toast("取消成功");
            this.getBookingList();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    goDetail(item) {
      this.$router.push({
        name: "SalonDetail",
        query: {
          booking_id: item.booking_id,
        },
      });
    },
    getBookingList() {
      const params = {
        ding_user_id: this.currentUserInfo.ding_user_id,
      };
      meetingService.getBookingList(params).then((res) => {
        this.bookingList = res.booking_list;
        this.finishList = res.finish_list;
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.salon-list {
}
.salon-list-title {
  padding: 5px 15px;
}
.salon-list-item {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 20px 15px;
  padding-bottom: 5px;
  .salon-list-item-infor {
    display: flex;
    justify-content: space-between;
  }
  .salon-list-item-infor-name {
    font-size: 16px;
    font-weight: 900;
  }
  .salon-list-item-infor-time {
    font-size: 14px;
    font-weight: 300;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .salon-list-item-btn {
    display: flex;
    justify-content: space-between;
  }
}
.salon-list-finish {
  .salon-list-item-btn {
    .el-button {
      flex: 1;
    }
  }
}
</style>